var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui message"},_vm._l((this.config.help),function(riga){return _c('span',{domProps:{"innerHTML":_vm._s(riga)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }